import React, { useState, useEffect, useRef } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

// ✏️ Aa object ma badhu manually change kari shako
const CARD = {
    bgColor: "#E8434B",
    question: "Main kaisa lagta hoon? 🔥",

    categoryLabel: "CATEGORY",
    categoryBoxBg: "#FFD1D9",

    // 👇 Emoji image URL (aa change karo)
    emojiUrl: "https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f42f.svg",
    emojiLabel: "Animal",

    audioTitle: "🎧 Kyun ye animal? Voice suno",
    duration: "0:11",
    durationSeconds: 11,

    replyLabel: "MERA JAWAB 👇",
    replyPlaceholder: "✏️ Tap karke reply likho",
    replyBoxHeight: 120,

    cardHeight: 620,       // reply box dekhay tyare card height
    cardHeightHidden: 500, // eye click kari reply box hide thay tyare card height
};

const BARS = [
    6, 10, 16, 8, 20, 12, 7, 18, 24, 14, 9, 22, 12, 6, 16, 26, 18, 10, 7, 20,
    14, 8, 22, 12, 18, 9, 6, 15, 24, 11, 8, 19, 13, 7, 21, 10, 16, 7, 18, 24, 14, 9, 22, 12, 6, 16, 26, 18,
    12, 18, 9, 6, 15, 24, 11, 8, 19, 12, 18, 9, 6, 15, 24, 11, 8, 19,
];

const buildWave = (teeth = 14, w = 280, h = 14) => {
    const step = w / teeth;
    let d = `M0 0 L0 ${h * 0.4}`;
    for (let i = 0; i < teeth; i++) {
        const x = i * step;
        d += ` Q${x + step / 4} ${h}, ${x + step / 2} ${h * 0.5} T${x + step} ${h * 0.4}`;
    }
    d += ` L${w} 0 Z`;
    return d;
};

const CardPreviewQue6 = ({ image }) => {
    const [playing, setPlaying] = useState(false);
    const [progress, setProgress] = useState(0); // 0 - 1
    const [showReply, setShowReply] = useState(true);
    const timerRef = useRef(null);

    useEffect(() => {
        if (!playing) return;
        const stepMs = 100;
        timerRef.current = setInterval(() => {
            setProgress((p) => {
                const next = p + stepMs / (CARD.durationSeconds * 1000);
                if (next >= 1) {
                    clearInterval(timerRef.current);
                    setPlaying(false);
                    return 0;
                }
                return next;
            });
        }, stepMs);
        return () => clearInterval(timerRef.current);
    }, [playing]);

    const activeBars = Math.floor(progress * BARS.length);

    return (
        <div className="Satoshi absolute top-0 left-1/2 h-full flex flex-col items-center justify-center w-full transform -translate-x-1/2 text-gray-800 text-center">
            <div
                className="relative flex flex-col items-center rounded-3xl border-4 border-black w-full"
                style={{
                    height: `${showReply ? CARD.cardHeight : CARD.cardHeightHidden}px`,
                    transition: "height 0.3s ease",
                    backgroundColor: CARD.bgColor,
                    backgroundImage: image ? `url(${image})` : "none",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                {/* Header (white, wavy bottom) */}
                <div className="relative w-full bg-white px-6 pt-7 pb-6 z-10 flex-shrink-0 rounded-t-3xl">
                    <p className="SatoshiBold text-black text-[17px] font-bold" style={{ lineHeight: "22px" }}>
                        {CARD.question}
                    </p>
                    <svg
                        viewBox="0 0 280 14"
                        preserveAspectRatio="none"
                        className="absolute left-0 w-full"
                        style={{ bottom: "-13px", height: "14px" }}
                    >
                        <path d={buildWave()} fill="#fff" />
                    </svg>
                </div>

                {/* Body - badha elements vacche same gap */}
                <div className="flex-1 w-full flex flex-col justify-evenly items-center">
                    {/* CATEGORY box + emoji + label pill */}
                    <div className="relative flex flex-col items-center">
                        {/* Dark pill label */}
                        <div className="SatoshiBold absolute left-1/2 -translate-x-1/2 -top-[12px] z-10 bg-[#1a1a1a] text-white text-[12px] font-bold tracking-[1.5px] px-5 py-[3px] rounded-full whitespace-nowrap">
                            {CARD.categoryLabel}
                        </div>

                        {/* Pink square box with emoji */}
                        <div
                            className="flex justify-center items-center border-2 border-[#1a1a1a] rounded-[18px]"
                            style={{
                                width: "170px",
                                height: "170px",
                                backgroundColor: CARD.categoryBoxBg
                            }}
                        >
                            <img
                                src={CARD.emojiUrl}
                                alt={CARD.emojiLabel}
                                style={{ width: "92px", height: "92px", objectFit: "contain" }}
                            />
                        </div>

                        {/* Label pill (box ni border par overlap) */}
                        <div className="SatoshiBold -mt-5 relative z-10 bg-white border-2 border-[#1a1a1a] rounded-full px-6 py-[3px] text-[17px] font-bold text-black">
                            {CARD.emojiLabel}
                        </div>
                    </div>

                    {/* Audio player */}
                    <div className="w-full px-4">
                        <div className="flex items-center gap-3 bg-white border-2 border-[#1a1a1a] rounded-full pl-2 pr-4 py-2 w-full">
                            <button
                                type="button"
                                onClick={() => setPlaying((p) => !p)}
                                className="flex-shrink-0 w-[40px] h-[40px] rounded-full bg-black flex items-center justify-center"
                            >
                                {playing ? (
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="#fff">
                                        <rect x="5" y="4" width="5" height="16" rx="1" />
                                        <rect x="14" y="4" width="5" height="16" rx="1" />
                                    </svg>
                                ) : (
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="#fff" style={{ marginLeft: "2px" }}>
                                        <path d="M6 4l14 8-14 8z" />
                                    </svg>
                                )}
                            </button>

                            <div className="flex-1 flex flex-col items-start min-w-0">
                                <span className="Satoshi text-[11px] text-[#444] font-semibold truncate w-full text-left">
                                    {CARD.audioTitle}
                                </span>
                                <div className="flex items-center gap-[2px] h-[28px] w-full">
                                    {BARS.map((h, i) => (
                                        <div
                                            key={i}
                                            style={{
                                                width: "3px",
                                                height: `${h}px`,
                                                borderRadius: "2px",
                                                background: i < activeBars ? "#F0197D" : "#1a1a1a",
                                                transition: "background 0.1s",
                                                flexShrink: 0,
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>

                            <span className="SatoshiBold text-[12px] font-bold text-black flex-shrink-0">
                                {CARD.duration}
                            </span>
                        </div>
                    </div>

                    {/* Reply box - eye click par hide thay */}
                    {showReply && (
                        <div className="w-full px-4">
                            <div
                                className="bg-white border-2 border-[#1a1a1a] rounded-[16px] px-4 py-3 w-full text-left"
                                style={{ minHeight: `${CARD.replyBoxHeight}px` }}
                            >
                                <p className="SatoshiBold text-[11px] font-bold text-[#555] tracking-wide">
                                    {CARD.replyLabel}
                                </p>
                                <p className="Satoshi text-[15px] text-[#8a8a8a] font-semibold mt-1">
                                    {CARD.replyPlaceholder}
                                </p>
                            </div>
                        </div>
                    )}
                </div>

                {/* Eye icon (FontAwesome, center ma, click toggle) */}
                <button
                    type="button"
                    onClick={() => setShowReply((s) => !s)}
                    className="absolute -bottom-3 -right-3 w-[46px] h-[46px] rounded-full bg-black flex items-center justify-center z-20"
                >
                    {showReply ? (
                        <FaEye color="#fff" size={18} />
                    ) : (
                        <FaEyeSlash color="#fff" size={18} />
                    )}
                </button>
            </div>
        </div>
    );
};

export default CardPreviewQue6;